import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { GetIcon } from "../icons/GetIcon.js";

function createMarkup(htmlstring) {
  return { __html: htmlstring };
}

function formatDate(date) {
  let month = (1 + date.getMonth()).toString(),
    day = date.getDate().toString(),
    year = date.getFullYear();

  month = month.length > 1 ? month : "0" + month;
  day = day.length > 1 ? day : "0" + day;

  return month + "/" + day + "/" + year;
}

export default class ArticleCard extends React.Component {
  constructor(props) {
    super(props);
  }

  renderPaper = (paper, i, count) => {
    let separator = "",
      paper_type = "Working";

    if (count - 1 > i) {
      separator = ", ";
    }

    if (paper.url.indexOf("center-papers") != -1) {
      paper_type = "Center";
    }

    return (
      <span key={i}>
        <a href={paper.url}>
          {paper_type} Paper {paper.id}
        </a>
        {separator}
      </span>
    );
  };

  componentDidUpdate() {
    // const { index, loading } = this.props;
    // if (0 == index && !loading) {
    // this.itemWrapper.focus();
    // }
  }

  render() {
    const {
      abstract,
      authors,
      quote,
      displaytypename,
      editors,
      imageurl,
      lecturetypename,
      papers,
      presenters,
      publisheddate,
      displaydate,
      title,
      type,
      url,
      videoimageurl,
      issueNum,
      publicationtypename,
      issueprint,
    } = this.props;

    const ariaLabel = "Read the full article on " + title;
    const cardClass = classNames("digest-card");

    return (
      <div className={cardClass}>
        {title && (
          <div className="digest-card__title">
            <a ref={(el) => (this.itemWrapper = el)} href={url}>
              {title}
            </a>
          </div>
        )}
        {quote && <div className="digest-card__summary quote">{quote}</div>}
        {abstract && !quote && (
          <div className="digest-card__summary abstract">
            {abstract}&hellip;
          </div>
        )}
        <div className="page-header__citation-info">
          {displaydate && (
            <div className="page-header__citation-item">
              <div>
                {formatDate(new Date(displaydate))}
              </div>
            </div>
          )}
          {papers && (
            <div className="page-header__citation-item">
              <div>
                Summary of{" "}
                {papers.map((paper, i) =>
                  this.renderPaper(paper, i, papers.length)
                )}
              </div>
            </div>
          )}
          {(publicationtypename && issueprint) && (
            <div className="page-header__citation-item print">
              <span className="page-header__citation-subtitle">
                Featured in print{" "}
                <em>{publicationtypename.replace(/^The\s+/, "")}</em>
              </span>
              <a href={issueprint} className="pdf-link">
                {GetIcon("pdf")}
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const { array, bool, func, number, string } = PropTypes;

ArticleCard.propTypes = {
  abstract: string,
  authors: array,
  quote: string,
  displaytypename: string,
  editors: array,
  index: number,
  imageurl: string,
  lecturetypename: string,
  loading: bool,
  papers: array,
  presenters: array,
  publisheddate: string,
  displaydate: string,
  title: string,
  type: string,
  url: string,
  videoimageurl: string,
  issueNum: number,
};

ArticleCard.defaultProps = {};
